import { render, staticRenderFns } from "./List.vue?vue&type=template&id=ba992416&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=ba992416&prod&scoped=true&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&id=ba992416&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba992416",
  null
  
)

export default component.exports